import Nav from '../Components/nav';

const Hero = () => {
	return (
		<>
			<section className="hero">
				<Nav />

				<div className="hero_wrapper">
					<div className="hero_content">
						<div className="hero_content__image">
							<img src="/img/kent-roth.jpg" alt="Kent Roth" />
							<p className="name">Kent Roth</p>
						</div>
						<div className="hero_content__copy">
							<h1>
								Front-end developer always learning, creating
								and improving.
							</h1>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Hero;
